import { GetResponse } from '@customTypes/api/IAMAssignedRole';
import { Endpoints, KrakendServiceAPI, ServiceAPI } from '@service/index';
import featureFlagManagerForInitialization from '@service/initializationFeatureFlags';
import queryKeys from '@src/queries/keys';

import { useQuery } from '../helper/useQuery';

const useGetIAMAssignedPermission = (enabled = true) =>
  useQuery<GetResponse>(
    [queryKeys.getIAMRoles],
    async () => {
      const isMock = import.meta.env.VITE_ENV !== 'production';
      const isAgencyRelatedEndpoint =
        isMock &&
        featureFlagManagerForInitialization.getIsKeycloakLoginWithSso();

      const endpoint = isAgencyRelatedEndpoint
        ? Endpoints.IAMAssignedPermissionMock()
        : Endpoints.IAMAssignedPermission();
      const res = isAgencyRelatedEndpoint
        ? await KrakendServiceAPI.get<void, GetResponse>(endpoint)
        : await ServiceAPI.get<void, GetResponse>(endpoint);
      return res.data;
    },
    {
      cacheTime: 31556952000,
      refetchOnMount: false,
      enabled,
    },
  );

export default useGetIAMAssignedPermission;
